export { AccordionAdapter } from "./AccordionAdapter";
export type { AccordionAdapterProps } from "./types";
